/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../usermessagetype.ts" />
/// <reference path="app.common.services.module.ts" />
/// <reference path="../iresultwithmessages.d.ts" />

module App.Common.Services {
	'use strict';

	export class AddressFinderService {

		public static $inject = [
			'$q',
			'app.common.services.logService',
			'$localStorage',
			'app.common.services.globalSettingsService',
			'app.common.services.apiService'
		];

		constructor(private $q: angular.IQService,
			private logger: Services.LogService,
			private $localStorage: Common.ILocalStorage,
			private globalSettings: Services.GlobalSettingsService,
			private api: Services.ApiService) {
		}

		public find(postcode: string): angular.IPromise<Hca.HiLO.ViewModel.IAddressViewModel[]>;

		public find(postcode: string, doorNumber?: string) : angular.IPromise<Hca.HiLO.ViewModel.IAddressViewModel[]>{

			var params;

			//check if doorNumber is provided
			if (doorNumber) {
				params = {
					postcode: postcode,
					doorNumber: doorNumber
				};
			} else {
				params = { postcode: postcode };
			}
			
			return this.api.get({
				resourceName: 'Address',
				params: params
			}).then((data: Hca.HiLO.ViewModel.IAddressViewModel[]): any => {
				return data;
			});	

		}
	}

	angular
		.module('app.common.services')
		.service('app.common.services.addressFinderService', AddressFinderService);
}